import Immutable from 'immutable';
import { COLLECTION_SHAPE } from '../../../config/shapes';
import {
  CLEAR_SECURITY_PROFILES,
  FLAG_GETTING_SECURITY_PROFILES,
  GET_SECURITY_PROFILES,
} from '../../../actions/types/security/SecurityProfile';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
});

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case FLAG_GETTING_SECURITY_PROFILES:
      return state.setIn(['all', 'loading'], payload);
    case GET_SECURITY_PROFILES:
      return state.setIn(['all', 'content'], Immutable.Map(payload));
    case CLEAR_SECURITY_PROFILES:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    default:
      return state;
  }
};
